//ENDPOINTS CORREOS Y EVENTOS
//correos
export const urlCorreos = "/api/correo"
//eventos
export const urlEventos = "/api/correo/evento"
//vincular / desvincular
export const urlCorreoEventoLista = "/api/correo/evento/lista" 